import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Button, Spinner, Badge } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next"

import { debounce, map, range } from "lodash"
import moment from "moment"

import ToolkitProvider from "react-bootstrap-table2-toolkit"
import MyPagination from "../../components/Common/MyPagination"

//actions

import "../../assets/scss/datatables.scss"
import { AvField, AvForm } from "availity-reactstrap-validation"
import DeleteModal from "components/Common/DeleteModal"
import { deleteSale, getExcelDownloadInspectionBooking } from "store/actions"
import { useHistory, useLocation } from "react-router-dom"
import { getInspectionsBooking } from "store/inspection/actions"
import ExcelDownload from "hooks/useExcelDownloadButton"
import useRole from "hooks/useRole"

const AllInspectionBookings = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const isTablet = window.innerWidth <= 768
  const { currentRole } = useRole()

  const [sort, setSort] = useState("all")
  const location = useLocation()

  const [totalItemLimit, setTotalItemLimit] = useState(() => {
    return parseInt(localStorage.getItem("bookingLimit")) || 20
  })
  const [page, setPage] = useState(null)
  const [SearchText, setSearchText] = useState("")

  const [finalDateFormated, setFinalDateFormated] = useState({
    from: "",
    to: "",
  })
  useEffect(() => {
    setPage(1)
  }, [])
  const {
    AllInspectionBookings,
    total,
    loading,
    bookingCounts,
    allExcelBooking,
  } = useSelector(state => ({
    AllInspectionBookings: state.Inspection.inspectionsBooking?.bookings,
    bookingCounts: state.Inspection.inspectionsBooking?.bookingCounts,
    total: state.Inspection.inspectionsBooking?.total,
    loading: state.Sale.loading,
    allExcelBooking:
      state?.ExcelDownload?.excelDownloadInspectionBooking?.bookings || [],
  }))

  const handleDateSearch = () => {
    if (
      finalDateFormated?.from?.length >= 1 &&
      finalDateFormated?.to?.length >= 1
    ) {
      return finalDateFormated
    } else {
      return {
        from: "",
        to: "",
      }
    }
  }

  //delete
  const [isOpen, setIsOpen] = useState({ stauts: false, id: "" })
  const [formModal, setFormModal] = useState({ status: false, data: "" })

  const handleDeleteEvent = () => {
    setIsOpen({ ...isOpen, stauts: false })
    dispatch(deleteSale(isOpen?.id, history))
  }

  const updatedLocation = {
    ...location,
    state: {
      ...location.state,
      page: 1,
    },
  }

  //pagination
  const totalPages = Math.ceil(total / totalItemLimit)
  const pages = range(1, totalPages + 1)

  useEffect(() => {
    dispatch(
      getInspectionsBooking(
        page,
        sort,
        totalItemLimit,
        SearchText,
        handleDateSearch()
      )
    )
  }, [dispatch, sort, page, totalItemLimit, SearchText, finalDateFormated])

  const columns = [
    {
      dataField: "no",
      text: "No.",
      sort: true,
    },

    {
      dataField: "customer",
      text: "Name",
      sort: true,
    },
    {
      dataField: "customer_contact",
      text: "Phone",
      sort: true,
    },
    {
      dataField: "vehicle_brand",
      text: "Vehicle",
      sort: true,
    },
    {
      dataField: "status",
      text: "Booking Status",
      sort: true,
    },
    {
      dataField: "payment",
      text: "Payment Status",
      sort: true,
    },

    {
      dataField: "action",
      classes: "text-center action-cell",
      headerClasses: "text-center action-cell",
      text: "Action",
    },
  ]

  const formattedCreateDates = item => {
    return moment(item?.createdAt).format("DD/MM/YYYY h:m:a")
  }

  const statusOptions = [
    { label: "New", value: "NEW" },
    { label: "Pending", value: "PENDING" },
    { label: "Processing", value: "PROCESSING" },
    { label: "Completed", value: "COMPLETED" },
  ]

  const handleAllUpdatePage = id => {
    history.push(`/inspection-booking/update/${id}`)
  }
  const handleSingleViewPage = id => {
    history.push(`/inspection-booking/details/${id}`)
  }

  const getStatusColor = status => {
    switch (status) {
      case "NEW":
        return "primary"
      case "PENDING":
        return "warning"
      case "PROCESSING":
        return "secondary"
      case "COMPLETED":
        return "success"
      default:
        return "light" // fallback
    }
  }

  const formatStatusLabel = status => {
    return status
      ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
      : "-"
  }

  const inspectionBookingData = map(
    AllInspectionBookings?.length >= 1 ? AllInspectionBookings : [],
    (item, index) => ({
      ...item,
      key: index,
      no: <span>{index + 1 + (page - 1) * totalItemLimit}</span>,
      booking_date: moment(item?.createdAt).format("DD/MM/YYYY - h:mm A"),
      booking_id: <p className="mb-0">{item?.booking_id}</p>,

      customer: (
        <div
          style={{
            maxWidth: "200px",
            minWidth: "100px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={item?.name} // optional: shows full name on hover
        >
          {item?.user_details?.name?.charAt(0)?.toUpperCase() +
            item?.user_details?.name?.slice(1)}
        </div>
      ),
      customer_contact: (
        <span>
          {item?.user_details?.country_code
            ? `${item.user_details.country_code}-${item.user_details.phone}`
            : item?.user_details?.phone}
        </span>
      ),
      vehicle_brand: <span>{item?.vehicle_details?.brand?.name || "--"} </span>,
      status: (
        <Badge
          className={`font-size-12 badge-soft-${getStatusColor(
            item?.booking_status
          )} me-2 mt-1`}
          color=""
          pill
        >
          {formatStatusLabel(item?.booking_status)}
        </Badge>
      ),

      payment: (
        <span>
          <Badge
            style={{ textTransform: "capitalize", marginBottom: "7px" }}
            className={
              "px-2 py-2 badge-soft-" +
              (item?.payment_status?.is_paid === true
                ? "success"
                : item?.payment_status?.is_paid === false
                ? "info"
                : "secondary")
            }
          >
            {item?.payment_status?.is_paid === true
              ? "Paid"
              : item?.payment_status?.is_paid === false
              ? "Unpaid"
              : "-"}
          </Badge>
        </span>
      ),
      inspection_status: (
        <span>
          {item?.inspection?.status} <br />
          {item?.inspection?.id}
        </span>
      ),
      action: (
        <div
          className="d-flex gap-1"
          style={{ width: "100%", justifyContent: "center" }}
        >
          <Button
            id={`view${index}`}
            type="button"
            title="View Booking"
            color="white"
            className="ms-1 btn"
            onClick={() => handleSingleViewPage(item?._id)}
          >
            <i className="bx bx-show-alt " style={{ fontSize: "22px" }} />
          </Button>
          <Button
            title="Edit Booking"
            id={`view${index}`}
            type="button"
            color="white"
            className="ms-1 btn"
            onClick={() => handleAllUpdatePage(item?._id)}
          >
            <i className="bx bx-edit " style={{ fontSize: "22px" }} />
          </Button>
        </div>
      ),
    })
  )

  // eslint-disable-next-line no-unused-vars
  const handleTableChange = (type, { page, searchText }) => {
    setUserList()
  }

  const debounceUserSearch = debounce(value => setSearchText(value), 600)

  const handlePageLimit = e => {
    if (e.target.value >= 1) {
      setTotalItemLimit(parseInt(e.target.value))
      localStorage.setItem("bookingLimit", e.target.value)
    }
  }

  const handleRouteCreate = () => {
    history.push("/inspection-booking/create")
  }

  const statusValues = [
    { label: "All", value: "all", count: bookingCounts?.ALL || 0 },
    {
      label: "Pending",
      value: "PENDING",
      count: bookingCounts?.PENDING || 0,
    },
    { label: "New", value: "NEW", count: bookingCounts?.NEW || 0 },
    {
      label: "Processing",
      value: "PROCESSING",
      count: bookingCounts?.PROCESSING || 0,
    },
    {
      label: "Completed",
      value: "COMPLETED",
      count: bookingCounts?.COMPLETED || 0,
    },
  ]
  const handleStatusController = value => {
    switch (currentRole) {
      case "admin":
        return value
      case "generalManager":
        return value
      case "managingDirecter":
        return value
      case "branchManager":
        return ""
    }
  }
  const listChange = sortValue => {
    setSort(sortValue)
    if (location?.pathname === "/dashboard") {
      return ""
    } else {
      history?.push({
        pathname: location.pathname,
        search: `p=${page}&s=${sortValue}`,
        state: {
          page: page,
          sort: handleStatusController(sortValue),
        },
      })
    }
  }
  useEffect(() => {
    if (location?.state?.sort) {
      setSort(location?.state?.sort)
    }
  }, [location])

  const [isExcelLoading, setIsExcelLoading] = useState(false)

  const handleExcelDownload = async () => {
    setIsExcelLoading(true)
    try {
      await dispatch(
        getExcelDownloadInspectionBooking(
          page,
          sort,
          totalItemLimit,
          SearchText,
          handleDateSearch()
        )
      )
    } finally {
      setIsExcelLoading(false)
    }
  }

  const headers = [
    { label: "No", key: "no" },
    { label: "Date", key: "createdAt" },
    { label: "Booking Id", key: "booking_id" },
    { label: "Name", key: "name" },
    { label: "Phone", key: "phone" },
    { label: "Whatsapp No.", key: "whatsapp" },
    { label: "Status", key: "status" },
    { label: "Vehicle Brand", key: "vehicle_details" },
    { label: "Payment Type", key: "payment_type" },
    { label: "District", key: "district" },
    { label: "State", key: "state" },
  ]

  const excelDownloadBooking = map(allExcelBooking, (item, key) => ({
    ...item,
    no: key + 1,
    createdAt: formattedCreateDates(item),
    booking_id: item?.booking_id,
    name: item?.user_details?.name,
    phone: item?.user_details?.country_code
      ? `${item.user_details.country_code}-${item.user_details.phone}`
      : item?.user_details?.phone,
    status: item.booking_status,
    payment_type: item?.payment_type,
    whatsapp: item?.user_details?.whatsapp,
    district: item?.user_details?.district?.name || "---",
    state: item?.user_details?.state?.name || "---",
    vehicle_details: item?.vehicle_details?.brand?.name || "--",
  }))

  return (
    <React.Fragment>
      <DeleteModal
        show={isOpen?.stauts}
        onCloseClick={() => setIsOpen({ ...isOpen, stauts: false })}
        onDeleteClick={handleDeleteEvent}
      />
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <div>
                <ToolkitProvider
                  keyField="_id"
                  columns={columns}
                  data={inspectionBookingData}
                  search
                >
                  {toolkitProps => (
                    <React.Fragment>
                      <div className="mb-3 d-flex justify-content-between">
                        <div>
                          {map(statusValues, (head, key) => (
                            <>
                              <input
                                type="radio"
                                className="btn-check"
                                name={`btn-radio${key + 1}`}
                                id={head?.value}
                                autoComplete="off"
                                checked={sort === head?.value}
                                onChange={() => listChange(head?.value, key)}
                              />
                              <label
                                className="btn btn-warning "
                                htmlFor={head?.value}
                                style={{
                                  borderRadius: 1,
                                }}
                              >
                                {head?.label}
                                <Badge
                                  className={`font-size-12 ms-2 ${
                                    sort === head.value
                                      ? "badge-soft-light"
                                      : "badge-soft-light"
                                  }`}
                                  pill
                                >
                                  {head?.count}
                                </Badge>
                              </label>
                            </>
                          ))}
                        </div>
                        <div className="pb-0 d-flex align-items-center justify-content-end ">
                          <div style={{ marginTop: "-6px" }}>
                            <Button
                              color="warning"
                              className="px-4 btn-rounded"
                              onClick={handleRouteCreate}
                            >
                              <i className="mdi mdi-plus me-1" />
                              Create{" "}
                            </Button>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center justify-content-between py-3 px-2">
                        <div className="d-flex w-50">
                          <div className="w-100">
                            <div className="search-box mb-2 d-flex">
                              <div className="position-relative ">
                                <AvForm>
                                  <AvField
                                    name="searchText"
                                    placeholder="Search..."
                                    type="text"
                                    onChange={e =>
                                      debounceUserSearch(e.target.value)
                                    }
                                    style={{
                                      width: isTablet ? "200px" : "300px",
                                    }}
                                  />
                                </AvForm>
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </div>

                          <div>
                            <AvForm className="form-horizontal mx-2 mb-0 d-flex align-items-center">
                              <div className="mx-1">
                                <span className="">
                                  Show
                                  <i className="fas fa-sort-numeric-down-alt mx-1"></i>
                                </span>
                              </div>
                              <div className="" style={{ width: "50px" }}>
                                <AvField
                                  name="pageLimit"
                                  className="form-control"
                                  value={totalItemLimit}
                                  onChange={e => handlePageLimit(e)}
                                  type="text"
                                  required
                                />
                              </div>
                            </AvForm>
                          </div>
                        </div>
                        <AvForm style={{ marginTop: "-20px" }}>
                          <span className="mt-1 ">Sort By Booking Date</span>
                          <div className={`d-flex date_wrapper  `}>
                            <div className="d-flex align-items-start position-relative">
                              <AvField
                                name="dateRange"
                                type="date"
                                validate={{
                                  dateRange: {
                                    start: { value: -5, units: "years" },
                                    end: { value: 5, units: "years" },
                                  },
                                }}
                                onChange={e => {
                                  setFinalDateFormated({
                                    ...finalDateFormated,
                                    from: e.target.value,
                                  })
                                  history.push(updatedLocation)
                                }}
                                value={finalDateFormated?.from}
                              />
                              <button
                                onClick={() => {
                                  setFinalDateFormated({
                                    ...finalDateFormated,
                                    from: "",
                                  })
                                  history.push(updatedLocation)
                                }}
                                type="button"
                                className="btn btn-white editable-cancel date_close btn-sm"
                              >
                                <i className="mdi mdi-close text-danger "></i>
                              </button>
                            </div>
                            <div className="d-flex align-items-start position-relative">
                              <AvField
                                name="dateRange"
                                className="mx-1"
                                type="date"
                                validate={{
                                  dateRange: {
                                    start: { value: -5, units: "years" },
                                    end: { value: 5, units: "years" },
                                  },
                                }}
                                onChange={e =>
                                  setFinalDateFormated({
                                    ...finalDateFormated,
                                    to: e.target.value,
                                  })
                                }
                                value={finalDateFormated?.to}
                              />
                              <button
                                onClick={() =>
                                  setFinalDateFormated({
                                    ...finalDateFormated,
                                    to: "",
                                  })
                                }
                                type="button"
                                className="btn btn-white editable-cancel date_close btn-sm"
                              >
                                <i className="mdi mdi-close text-danger "></i>
                              </button>
                            </div>
                          </div>
                        </AvForm>

                        {/* <div className="pb-0 d-flex align-items-center justify-content-end">
                          <div>
                            <Button
                              color="warning"
                              className="px-4"
                              onClick={handleRouteCreate}
                            >
                              <i className="mdi mdi-plus me-1" />
                              New Booking
                            </Button>
                          </div>
                        </div> */}
                      </div>

                      {loading ? (
                        <Spinner color="secondary" className="d-block m-auto" />
                      ) : (
                        <>
                          {AllInspectionBookings?.length ? (
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    // keyField={"id"}
                                    key={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    // defaultSorted={defaultSorted}
                                    // selectRow={selectRow}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    onTableChange={handleTableChange}
                                  />
                                </div>
                              </Col>
                            </Row>
                          ) : (
                            <p
                              className="my-4 mx-3 "
                              style={{ textTransform: "capitalize" }}
                            >
                              No Inspection Bookings!
                            </p>
                          )}
                          <div className="d-flex align-items-center justify-content-between px-4">
                            <div className="w-100">
                              <MyPagination
                                totalPages={pages}
                                page={page}
                                setPage={setPage}
                              />
                            </div>
                            <div>
                              <>
                                {allExcelBooking?.length >= 1 ? (
                                  <ExcelDownload
                                    title="Booking Reports"
                                    headers={headers}
                                    excelDownloadData={excelDownloadBooking}
                                    isLoading={isExcelLoading}
                                    onDownloadClick={handleExcelDownload}
                                  />
                                ) : null}
                              </>
                            </div>
                          </div>
                        </>
                      )}
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default AllInspectionBookings
